import { Component, Input } from "@angular/core";
import { INavItem, NavItemsSectionConfig } from "@webapp/navigation/models/nav-items-list.models";
import { ICollection } from "@gtmhub/models";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { FavoritesService } from "@gtmhub/favorites/favorites.service";
import { UIErrorHandlingService } from "@gtmhub/error-handling";

@Component({
  selector: "gh-nav-items-list",
  templateUrl: "./nav-items-list.component.html",
  styleUrls: ["./nav-items-list.component.less"],
})
export class NavItemsListComponent {
  @Input()
  public config: NavItemsSectionConfig;
  @Input()
  public collection: ICollection<INavItem>;
  public expanded = true;
  public seeMore: boolean;

  constructor(protected favoritesService: FavoritesService, private uiErrorHandlingService: UIErrorHandlingService) {}

  drop(event: Partial<CdkDragDrop<string[]>>) {
    if (event.previousIndex === event.currentIndex || this.config.itemsGroupType !== "favorites") {
      return;
    }

    const item = this.collection.items[event.previousIndex];
    const newOrder = event.currentIndex + 1;

    this.favoritesService.reorderFavoriteItem(item.favoriteId, newOrder).then(
      () => {
        moveItemInArray(this.collection.items, event.previousIndex, event.currentIndex);
      },
      (err) => {
        this.uiErrorHandlingService.handleModal(err);
      }
    );
  }
}
